module.exports = __webpack_public_path__ + "img/tsg.cfa42141.png";